module.exports = __webpack_public_path__ + "img/karura.ecbf18b0.svg";